import React, { useState } from "react";
import ImageWithBasePath from "../../core/data/img/ImageWithBasePath";
import OnboardingTabs from "./Onboarding/OnboardingTabs";

const AthleteDashboard = () => {

    const onboardstep = localStorage.getItem("onboardStep");
    const [isLoading, setIsLoading] = useState(false);

    return (
        <>
            {onboardstep !== "6" && <OnboardingTabs />}

            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Dashboard</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default AthleteDashboard;